<div class="training-materials" data-cy="training-materials-body">
  <div class="training-materials-container">
    @for (file of fileNames; track file) {
      <button type="button"
              class="training-materials-item"
              [disabled]="!!downloadInProgressFileName"
              (click)="downloadFile(file)"
              [attr.data-cy]="'training-materials-file-' + file">
        <app-file-preview [extension]="getExtension(file)"></app-file-preview>
        <span class="training-materials-file-name" [title]="file">{{ file }}</span>
        <span class="iwp-icon-gen_download training-materials-download-icon"></span>
      </button>
    }
  </div>
</div>



